import { Dispatch }          from "redux";
import FetchStatusRepository from "../../../domain/fundamentals/fetch/FetchStatusRepository";
import Notice                from "../../../domain/notice/Notice";
import NoticeContent         from "../../../domain/notice/NoticeContent";
import NoticeRepository      from "../../../domain/notice/NoticeRepository";
import Notices               from "../../../domain/notice/Notices";
import NoticeTitle           from "../../../domain/notice/NoticeTitle";
import FetchStatusDataSource from "../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import NoticeDataSource      from "../../../infrastructure/datasource/notice/NoticeDataSource";

class GetPublishNotice {
  constructor(
    private readonly dispatch: Dispatch,
    private readonly repository: NoticeRepository = new NoticeDataSource(dispatch),
    private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(dispatch)
  ) {
  }

  public async execute() {
    this.fetchStatusRepository.start();
    try {
      const response = await this.repository.findByPublish();
      if (response.data) {
        const list: Notice[] = response.data.notices.map((data) => new Notice(new NoticeTitle(data.title), new NoticeContent(data.content)));
        this.repository.store(new Notices(list));
      }
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default GetPublishNotice;
